module.exports = __webpack_public_path__ + "img/login.bb148ee0.png";